
export default function WhyItWorks() {
  const benefits = [
    {
      icon: 'ri-check-line',
      title: 'Professional Online Presence',
      description: 'Stand out with a modern, credible website that builds trust'
    },
    {
      icon: 'ri-check-line',
      title: 'More Customer Calls',
      description: 'Convert more visitors into paying customers with optimized design'
    },
    {
      icon: 'ri-check-line',
      title: 'Mobile Friendly',
      description: 'Perfect experience on all devices - phones, tablets, and desktops'
    },
    {
      icon: 'ri-check-line',
      title: 'No Monthly Website Fees',
      description: 'One-time investment with no recurring hosting or maintenance costs'
    },
    {
      icon: 'ri-check-line',
      title: 'Fast Turnaround',
      description: 'Get your demo website built and ready for review in days, not months'
    }
  ];

  return (
    <section className="relative py-32 bg-black overflow-hidden">
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-[#1e3a8a] rounded-full animate-pulse"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              opacity: Math.random() * 0.3 + 0.1
            }}
          ></div>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4">Why It Works</h2>
          <p className="text-xl text-white/70">Real results for real businesses</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {benefits.slice(0, 3).map((benefit, index) => (
            <div 
              key={index}
              className="bg-[#050a14] border-l-4 border-[#1e3a8a] rounded-2xl p-8 hover:bg-[#0a1628] transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-[#0a1628] border border-[#1e3a8a]/50 rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-2xl text-white/70`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">{benefit.title}</h3>
              <p className="text-white/70 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {benefits.slice(3).map((benefit, index) => (
            <div 
              key={index}
              className="bg-[#050a14] border-l-4 border-[#1e3a8a] rounded-2xl p-8 hover:bg-[#0a1628] transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 bg-[#0a1628] border border-[#1e3a8a]/50 rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-2xl text-white/70`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">{benefit.title}</h3>
              <p className="text-white/70 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
